import { Identifiers } from '../models/identifiers';
export class ProjectIdentifierQuery {
    constructor(config, queryService, buildResult) {
        this.config = config;
        this.queryService = queryService;
        this.buildResult = buildResult;
    }
    /**
     * For given Project by id
     * @param projectId ProjectId
     */
    projectId(projectId) {
        return this.buildResult(this.config, this.queryService, new Identifiers.ProjectIdentifier(Identifiers.ProjectIdentifierEnum.Id, projectId));
    }
}
//# sourceMappingURL=project-identifier-query.class.js.map